import React from 'react';
import { showNotification } from 'react-admin';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CardForm from '../../../components/CardForm';
import BillingForm from '../../../components/BillingForm';
import PaymentMethod from '../../../components/PaymentMethod';
import Typography from '@material-ui/core/Typography/Typography';
import Icon from '@material-ui/core/Icon/Icon';
import Button from '@material-ui/core/Button/Button';
import { convertPrice } from '../../../utils/index';

const styles = theme => ({
  page: {
    width: '90%',
    'max-width': '1140px',
    'margin-top': '54px',
    'margin-left': 'auto',
    'margin-right': 'auto',
  },
  textField: {
    width: '100%',
  },
  button: {
    paddingTop: theme.spacing(),
  },
  paymentMethod: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
  },
  title: {
    '&& > p': {
      color: 'rgba(33,35,34,0.5)',
      textTransform: 'uppercase',
      fontSize: 14,
      fontWeight: 500,
    },
  },
  summary: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 30,
    width: '100%',
    backgroundColor: 'rgba(237,237,237,0.5)',
    '&& > button': {
      marginRight: 'auto',
      marginLeft: 13,
    },
    '&& > p:nth-child(1)': {
      color: '#212322',
      fontSize: 20,
    },
    '&& > p:nth-child(3)': {
      color: '#212322',
      fontWeight: 500,
      fontSize: 36,
    },
    '&& > p:nth-child(3) > small': {
      fontWeight: 400,
      fontSize: 18,
    },
  },
  actions: {
    borderTop: '1px solid rgba(178,178,178,0.5)',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cancelButton: {
    backgroundColor: '#EDEDED',
    color: '#212322',
    marginRight: 7,
    '&&:hover': {
      backgroundColor: '#EDEDED',
    },
  },

});

export const stripeApiKey = process.env.REACT_APP_API_STRIPE_API_PUBLISHABLE_KEY;
const stripePromise = loadStripe(stripeApiKey);

class SubscriptionBilling extends React.Component {
  state = {
    billing: null,
    paymentMethod: 'card',
    cardToken: null,
    stripe: null,
  };

  renderCard = () => (
    <Elements stripe={stripePromise}>
      <CardForm
        onChange={(cardToken, stripe) => {
          this.setState({ cardToken, stripe });
        }}
      />
    </Elements>
  );

  changePaymentMethod(paymentMethod) {
    if (paymentMethod === 'invoice') {
      this.setState({ cardToken: null });
    }
    this.setState({ paymentMethod });
  }

  isValid() {
    const { billing, paymentMethod, cardToken } = this.state;
    return !!billing && (paymentMethod === 'card' ? !!cardToken : true);
  }

  handleSubmit = () => {
    const { onSubmit } = this.props;
    onSubmit(this.state);
  };

  render() {
    const { classes, paymentPeriod, currency, sum, onEdit, onCancel, pendingSubmit } = this.props;
    const { paymentMethod } = this.state;
    return (
      <Grid container spacing={5} className={classes.page} alignItems="flex-start">
        <Grid item xs={12}>
          <div className={classes.summary}>
            <Typography>Billed {paymentPeriod === 'month' ? 'monthly' : 'yearly'}</Typography>
            <Button variant="contained" color="primary" onClick={() => onEdit()}>
              <Icon>edit</Icon>
            </Button>
            <Typography>{convertPrice(sum, currency)}
              <small>/{paymentPeriod}</small>
            </Typography>
          </div>
        </Grid>
        <Grid item xs={7}>
          <Grid container spacing={5}>
            <Grid item xs={12} className={classes.title}>
              <Typography>payment method</Typography>
            </Grid>
            <Grid item xs={4}>
              <PaymentMethod type="card" checked={paymentMethod === 'card'}
                onClick={() => this.changePaymentMethod('card')}/>
            </Grid>
            {/* <Grid item xs={4}>*/}
            {/* <PaymentMethod type="invoice" checked={paymentMethod === 'invoice'}*/}
            {/* onClick={() => this.changePaymentMethod('invoice')}/>*/}
            {/* </Grid>*/}

            {paymentMethod === 'card' ?
              <React.Fragment>
                <Grid item xs={12} className={classes.title}>
                  <Typography>credit card info</Typography>
                </Grid>
                <Grid item xs={12}>
                  {this.renderCard()}
                </Grid>
              </React.Fragment>
              : null

            }
          </Grid>
        </Grid>
        <Grid item xs={5}>
          <Grid container spacing={5}>
            <Grid item xs={12} className={classes.title}>
              <Typography>billing information</Typography>
            </Grid>
            <Grid item xs={12}>
              <BillingForm
                onFormChange={data => {
                  this.setState({ billing: data });
                }}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.actions}>
          <Button
            variant="contained"
            color="primary"
            data-testid="start-subscription-cancel-button"
            className={classes.cancelButton}
            onClick={onCancel}
          >
            cancel
          </Button>
          <Button
            color="secondary"
            disabled={!this.isValid() || pendingSubmit}
            variant="contained"
            data-testid="start-subscription-button-second"
            onClick={this.handleSubmit}
          >
            get started
          </Button>
        </Grid>
      </Grid>
    );

  }
}

export default withStyles(styles)(connect(null, { showNotification })(SubscriptionBilling));
